<template>
  <div v-if="!loading">
    <div v-if="history.length">
      <div
        v-for="(version, index) in history"
        :key="index"
        class="w-100 d-flex flex-column align-items-start justify-content-center"
      >
        <b-button
          v-b-toggle="'accordion-' + index"
          variant="unstyled"
          :key="index"
          class="border-bottom rounded-0 w-100 d-flex justify-content-between"
        >
          <div>
            <span class="text-primary">{{ $t("field.version") }}</span>
            <span class="mr-4 font-weight-bold text-primary">{{
              version.version
            }}</span>
            <span class="ml-1 fs-12">{{ getDate(version[0].date) }}</span>
          </div>
          <div class="d-flex align-items-center justify-content-center">
            <b-button
              @click.stop="download(version[index].proposal_id)"
              variant="unstyled"
              :title="$t('actions.export')"
            >
              <font-awesome-icon :icon="faFilePdf" class="text-primary" />
            </b-button>
            <font-awesome-icon
              :icon="faChevronRight"
              class="accordion-icon text-primary ml-2"
            />
          </div>
        </b-button>
        <b-collapse
          :id="'accordion-' + index"
          class="mt-2 w-100"
          :visible="lastUpdate(index)"
        >
          <div class="container">
            <div
              class="d-flex align-items-center justify-content-between mt-2 mb-0"
            >
              <p class="item">
                <span class="font-weight-bold">{{ $t("field.status") }}</span>
              </p>
              <p class="item">
                <span class="font-weight-bold">{{ $t("field.date") }}</span>
              </p>
              <p class="item">
                <span class="font-weight-bold">{{ $t("field.user") }}</span>
              </p>
            </div>
            <div
              v-for="(item, i) in version"
              :key="i"
              class="border-bottom w-100"
            >
              <div
                v-if="itemHaveData(item)"
                class="mt-3 d-flex align-items-center justify-content-around"
              >
                <p class="item text-capitalize">
                  {{ item.status }}
                  <b-button
                    v-b-toggle="'collapse-' + index + i"
                    @click.stop="collapseStatus"
                    variant="unstyled p-0"
                    v-if="waitForApproval(item)"
                  >
                    <font-awesome-icon
                      :icon="isOpen ? faMinus : faPlus"
                      size="xs"
                      class="text-primary ml-2"
                    />
                  </b-button>
                </p>
                <p class="item">
                  {{ getDate(item.date) }}
                </p>
                <p class="item">
                  {{ item.user.name }}
                </p>
              </div>
              <b-collapse :id="'collapse-' + index + i">
                <div class="collapse-content bg-gray-100 fs-12">
                  <div
                    v-for="(approvals, index) in item.approvals"
                    :key="index"
                    class="d-flex align-items-center justify-content-between py-3"
                  >
                    <p class="item mb-0">
                      {{ getStatus(approvals.is_approved) }}
                      <b-button
                        v-if="rejectedProposal(approvals.is_approved)"
                        variant="unstyled"
                        class="p-0 d-flex justify-content-center ml-2"
                        v-b-popover.hover.top="approvals.rejection_reason"
                        :title="$t('history.motive')"
                      >
                        <font-awesome-icon
                          :icon="faInfoCircle"
                          class="text-primary"
                        />
                      </b-button>
                    </p>
                    <p class="item mb-0">{{ getDate(approvals.date) }}</p>
                    <p class="item mb-0">{{ approvals.user.name }}</p>
                  </div>
                </div>
              </b-collapse>
            </div>
          </div>
        </b-collapse>
      </div>
    </div>
    <div
      v-else
      class="w-100 h-100 d-flex align-items-center justify-content-center font-weight-bold"
    >
      {{ $t("messages.error_history") }}
    </div>
  </div>
  <div v-else>
    <spinner />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import budgetApi from '@/api/budgets'
import api from '@/api/proposal'
import moment from 'moment'
import {
  faChevronRight,
  faFilePdf,
  faPlus,
  faMinus,
  faInfoCircle
} from '@fortawesome/free-solid-svg-icons'
import downloadPDF from '@/mixins/downloadPDF'

export default {
  mixins: [downloadPDF],
  watch: {
    '$store.state.form.relationshipFields.status_id': {
      handler(id) {
        this.loading = true

        if (id) {
          this.init()
        }
      }
    }
  },
  data: () => ({
    budgetApi,
    api,
    loading: true,
    history: [],
    faChevronRight,
    faFilePdf,
    faPlus,
    faMinus,
    faInfoCircle,
    isOpen: false
  }),
  created() {
    this.init()
  },
  computed: {
    ...mapGetters({
      item: 'form/fields'
    })
  },
  methods: {
    async init() {
      try {
        const response = await this.budgetApi.history(this.item.id)

        if (response && response.data) {
          this.history = response.data
        } else {
          this.$toasted.error(this.$t('messages.unknown_error'))
        }
      } catch (e) {
        console.error(e)
      }

      this.loading = false
    },
    getDate(date) {
      return moment(date).format('DD-MM-YYYY HH:mm')
    },
    itemHaveData(item) {
      return typeof item === 'object'
    },
    lastUpdate(index) {
      if (index === 0) {
        return true
      }
    },
    waitForApproval(item) {
      return (
        item.status === this.$t('history.waiting_approval') &&
        item.approvals &&
        item.approvals.length
      )
    },
    getStatus(status) {
      if (status === null) {
        return this.$t('history.waiting_approval')
      } else if (status === true) {
        return this.$t('history.approved')
      } else if (status === false) {
        return this.$t('history.rejected')
      }
    },
    collapseStatus() {
      this.isOpen = !this.isOpen
    },
    rejectedProposal(status) {
      return status === false
    }
  }
}
</script>
<style lang="scss" scoped>
.item {
  width: 33%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
